import axiosClient from './axiosClient';

const vendorKycService = {
    getKyc: async () => {
        const response = await axiosClient.get('/vendor/kyc');
        return response.data;
    },
    submitKyc: async (payload) => {
        const response = await axiosClient.post('/vendor/kyc', payload);
        return response.data;
    },
    uploadFile: async (file) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await axiosClient.post('/vendor/kyc/upload-file', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    }
};

export default vendorKycService;
